<div class="manufacturer-grid-wrapper">
  <kendo-grid
    class="manufacturer-grid"
    [kendoGridBinding]="Order"
    [rowHeight]="rowHeight"
    [height]="gridHeight"
    [rowClass]="getRowClass"
    [pageSize]="pageSize"
    scrollable="virtual"
    [navigable]="false"
    [sortable]="true"
    [reorderable]="false"
    [resizable]="false"
  >
    <kendo-grid-command-column
      title="Visualizza"
      [width]="80"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <button
          type="button"
          class="manufacturer-icon-button manufacturer-icon-button--process"
          title="Processa ordine"
          (click)="openOrder(dataItem)"
        >
          <i class="bx bx-task"></i>
        </button>
      </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-column
      [width]="130"
      field="order_number"
      title="N&#176; ordine"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--order">
          {{ dataItem.order_number }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="120"
      field="order_date"
      title="Data ordine"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--date">
          {{ dataItem.order_date ? (dataItem.order_date | date: "dd/MM/yy") : "-" }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="180"
      field="delivery_date"
      title="Data prevista evasione"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--date">
          {{ dataItem.delivery_date ? (dataItem.delivery_date | date: "dd/MM/yy") : "-" }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="100"
      field="product_count"
      title="N&#176; articoli"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--articles">
          {{ formatArticleCount(dataItem.product_count) }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="100"
      field="article_count"
      title="N&#176; Pezzi"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--articles">
          {{ dataItem.article_count != null ? formatArticleCount(dataItem.article_count) : "-" }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="120"
      field="closing_date"
      title="Data chiusura"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--date">
          {{ dataItem.closing_date ? (dataItem.closing_date | date: "dd/MM/yy") : "-" }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
      <div class="manufacturer-empty-state">
        <p>Nessun ordine disponibile per questa vista.</p>
      </div>
    </ng-template>
  </kendo-grid>
</div>
